import type { Player } from '@acepoker/contract'
import { api } from './api'

export const getPlayer = async (): Promise<Player> => {
  const endpoint = `/api/player/info`
  return await api().get(endpoint).json<Player>()
}
